import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '@practium/features/auth';
import { UserHierarchyLevel } from '@practium/shared';
import { ProductsPage } from '@practium/features/products';
import type { ProductsTab } from '@practium/features/products';
import { usePermissions } from '@practium/features/permissions';

export const ProductsPageClient = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const currentUserId = user?._id || '';
	const { abilities } = usePermissions();

	const canRead = abilities.can('read', 'products');
	const permissions = {
		canCreate: abilities.can('create', 'products'),
		canEdit: abilities.can('update', 'products'),
		canDelete: abilities.can('delete', 'products'),
		canEditPublic: false,
	};

	const isFarmer = user?.hierarchyLevel === UserHierarchyLevel.Farmer;

	const addButtonText = isFarmer ? 'Solicitar' : (permissions.canCreate ? 'Adicionar' : undefined);
	const onAddButtonClick = isFarmer ? () => navigate('/solicitacoes') : undefined;

	const handleAddNew = (tab: ProductsTab) => {
		navigate(`/produtos/novo?type=${tab}`);
	};

	const handleViewItem = (tab: ProductsTab, id: string) => {
		navigate(`/produtos/ver?type=${tab}&id=${id}`);
	};

	if (!canRead) return <Navigate to="/" replace />;

	return (
		<ProductsPage
			permissions={permissions}
			currentUserId={currentUserId}
			getUserDisplayName={(userId) =>
				userId === currentUserId ? (user?.name ?? 'Criado por mim') : 'Cliente'
			}
			ownedByMeLabel="Criado por mim"
			onAddNew={handleAddNew}
			onViewItem={handleViewItem}
			addButtonText={addButtonText}
			onAddButtonClick={onAddButtonClick}
		/>
	);
};
